import Vue from 'vue'
import { MutationTree } from 'vuex'
import {
  ProductState,
  ProductDetailModelFull,
  ProductEstimate,
  AddonProduct,
  AddonProductOption,
  StockLibraryDesign
} from '@/product/types'
import { AdditionalOption } from '@/common/types'

const mutations: MutationTree<ProductState> = {
  setProductDetail(state, payload: ProductDetailModelFull) {
    const { estimate, ...others } = payload
    state.productDetail = others
    state.estimate = estimate
    state.addonProduct = {
      selectedAddonProductId: estimate.selectedAddonProductId || undefined,
      selectedAddonFirstOptionId: estimate.selectedAddonFirstOptionId || undefined
    }
  },
  updateProductNewSku(state, payload: ProductDetailModelFull) {
    const { estimate, ...others } = payload
    state.productDetail = { ...state.productDetail, ...others }
    state.estimate = estimate
  },
  updateEstimate(state, payload: ProductDetailModelFull) {
    const { estimate } = payload
    state.estimate = estimate
  },
  setImageLoading(state, payload: boolean) {
    state.imageLoading = payload
  },
  updateSelectedColorPattern(state, colorPatternId: number | string) {
    const pattern = state.productDetail.sku.skuColorPatterns?.find(item => item.id == colorPatternId)
    const updatedData = {
      ...state.estimate,
      selectedColorPattern: Object.assign({}, state.estimate.selectedColorPattern, pattern)
    }
    Vue.set(state, 'estimate', updatedData)
  },
  setSelectedId(
    state,
    { fieldName, id }: { fieldName: keyof ProductEstimate; id: number }
  ) {
    const updatedData = {
      ...state.estimate,
      [fieldName]: Object.assign({}, state.estimate[fieldName], { id })
    }
    Vue.set(state, 'estimate', updatedData)
  },
  setAddToEstimate(state, payload: boolean) {
    Vue.set(state.productDetail, 'addedToEstimate', payload)
  },
  setValidQuantity(state, payload) {
    state.validQuantity = payload
  },
  setServerError(state: ProductState, payload: boolean) {
    state.serverError = payload
  },
  setProductLoading(state: ProductState, payload: boolean) {
    state.productLoading = payload
  },
  setSizeInput(
    state: ProductState,
    payload: { id: number; quantity: number }[]
  ) {
    state.sizeInput = payload
  },
  setAddonProducts(state: ProductState, payload: AddonProduct[]) {
    state.addonProducts = payload
  },
  setAddonProduct(state, payload: AddonProductOption) {
    state.addonProduct = payload
  },
  setAdditionalOptions(state: ProductState, payload: AdditionalOption[]) {
    state.additionalOptions = payload
  },
  setSelectedAdditionalOptionIds(state: ProductState, payload: string[]) {
    state.selectedAdditionalOptionIds = payload
  },
  setPrefectureId(state, payload: string) {
    state.prefectureId = payload
  },
  setDeliveryDates(state,
    {
      shortestDeliveryDate,
      convenienceStoreShortestDeliveryDate
    } : {
      shortestDeliveryDate: keyof ProductEstimate;
      convenienceStoreShortestDeliveryDate: keyof ProductEstimate,
    }
  ) {
    const updatedData = {
      ...state.estimate,
      shortestDeliveryDate,
      convenienceStoreShortestDeliveryDate
    }
    Vue.set(state, 'estimate', updatedData)
  },
  setIsPrintingSelected(state, payload: boolean) {
    state.isPrintingSelected = payload
  },
  setStockLibraryDesign(state, payload: StockLibraryDesign) {
    Object.assign(state.stockLibraryDesign, payload)
  },
  updateSelectionErrorMessage(
    state,
    { errorType, errorMessage }: { errorType: string, errorMessage: string }
  ) {
    state.selectionErrors[errorType].errorMessage = errorMessage
  },
  highlightSelectionError(state, errorType: string) {
    state.selectionErrors[errorType].highlightInvalidElement = true
  },
  solveSelectErrorItem(state, errorType: string) {
    state.selectionErrors[errorType].highlightInvalidElement = false
  },
  setIsMobileView(state, value: boolean) {
    state.isMobileView = value
  },
  setSnackbarVisibility(state, payload: boolean) {
    state.snackbarMessage.isShown = payload
  },
  setMaxQuantity(state, value: number) {
    state.maxQuantity = value
  }
}

export default mutations
